<div class="modal-box ">
   <div class="text-end">
     <p (click)="close('skip')" role="button" class="modal-close-btn" aria-label="Close">&times;</p>
   </div>
 <div class="tour-welcome text-center">
      <h3>Welcome to your Business Account!  🎉</h3>
        <img src="assets/images/tour.png" alt="tour preview" class="w-100"/>
      <h6>Let’s take a quick tour</h6>
      <p>It’s going to take just a few seconds</p>

    </div>
    <div class=" d-flex justify-content-between">
      <button class="btn btn-trans" (click)="close('skip')">Skip Tour</button>
      <button class="btn btn-warning" (click)="close('start')">Take a Tour</button>
    </div>
</div>
